/**
 * Set a custom property with viewport width for use in full screen
 * blocks inside containers. Value is updated on resize.
 * Call init method to initialize.
 */

export default (function () {
    const getAdminBarHeight = function () {
        return document.querySelector('#wpadminbar')?.offsetHeight || 0
    }

    const setAdminBarCustomProperties = function () {
        document.documentElement.style.setProperty('--admin-bar-height', `${getAdminBarHeight()}px`)
    }

    const getStickyHeaderHeight = function () {
        return document.querySelector('[data-sticky-header]')?.offsetHeight || 0
    }

    const setStickHeaderCustomProperties = function () {
        document.documentElement.style.setProperty('--sticky-header-height', `${getStickyHeaderHeight()}px`)
    }

    const setScrollProperties = function () {
        const pos = window.scrollY

        if (pos > 0) {
            document.documentElement.classList.add('has-scrolled')
        } else {
            document.documentElement.classList.remove('has-scrolled')
        }

        document.documentElement.style.setProperty('--scroll-top', `${pos}px`)
    }

    const api = {}

    let resizeTimer

    api.init = function () {
        setAdminBarCustomProperties()
        setStickHeaderCustomProperties()

        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(function () {
                setAdminBarCustomProperties()
                setStickHeaderCustomProperties()
            }, 250)
        })

        window.addEventListener('scroll', function () {
            setStickHeaderCustomProperties()
            setScrollProperties()
        })
    }

    return api
})()
